// 导入路由组件
import Home from '../views/Home/Home'
import CoachSettleAgreement from '../views/Webview/CoachSettleAgreement'
import UserAgreement from '../views/Webview/UserAgreement'
import WXUserAgreement from '../views/Webview/WXUserAgreement'
import RechargeInstructions from '../views/Webview/RechargeInstructions'
import RechargeServiceAgreement from '../views/Webview/RechargeServiceAgreement'
import PrivacyPolicy from '../views/Webview/PrivacyPolicy'
import WXPrivacyPolicy from '../views/Webview/WXPrivacyPolicy'
import PersonalInformationList from '../views/Webview/PersonalInformationList'
import WXPersonalInformationList from '../views/Webview/WXPersonalInformationList'
import BillingRules from '../views/Webview/BillingRules'
import VerifiPage from '../views/Webview/VerifyPage'
import ExplanationCoachLevel from '../views/Webview/ExplanationCoachLevel'
import errorPage from '../views/404/404'
import AboutUsPage from '../views/AboutUs/index'
import ContactUs from '../views/ContactUs/index'
import RewardRules from '../views/Webview/RewardRules'
import PersonInfoCollectList from '../views/Webview/PersonInfoCollectList'

// 导入路由管理工具
import { RouteConfig } from 'react-router-config'
// import { getUserInfo } from '@/api/user'
// import { postActivityDetail } from '@/api/invite'
// import { store } from '@/store'
// import { setUserInfo } from "@/store/userInfo/action"
import { isiOS, jumpPage } from '@/utils/common'

const routes: RouteConfig = [
  {
    path: '/',
    exact: true,
    meta: { title: '小香风' },
    component: Home
  },
  {
    path: '/home',
    exact: true,
    meta: { title: '小香风' },
    component: Home
  },
  {
    path: '/about-us',
    meta: { title: '关于我们' },
    component: AboutUsPage
  },
  {
    path: '/contact-us',
    meta: { title: '联系我们' },
    component: ContactUs
  },
  {
    path: '/coach-settle-agreement',
    meta: { title: '教练入驻协议' },
    component: CoachSettleAgreement
  },
  {
    path: '/recharge-instructions',
    meta: { title: '充值说明' },
    component: RechargeInstructions
  },
  {
    path: '/recharge-service-agreement',
    meta: { title: '充值服务协议' },
    component: RechargeServiceAgreement
  },
  {
    path: '/user-agreement',
    meta: { title: '用户协议' },
    component: UserAgreement
  },
  {
    path: '/wx-user-agreement',
    meta: { title: '用户协议' },
    component: WXUserAgreement
  },
  {
    path: '/privacy-policy',
    meta: { title: '隐私政策' },
    component: PrivacyPolicy
  },
  {
    path: '/wx-privacy-policy',
    meta: { title: '隐私政策' },
    component: WXPrivacyPolicy
  },
  {
    path: '/personal-information-list',
    meta: { title: '与第三方共享个人信息清单' },
    component: PersonalInformationList
  },
  {
    path: '/wx-personal-information-list',
    meta: { title: '与第三方共享个人信息清单' },
    component: WXPersonalInformationList
  },
  {
    path: '/billing-rules',
    meta: { title: '计费规则' },
    component: BillingRules
  },
  {
    path: '/verifi-page',
    meta: { title: '实名认证' },
    component: VerifiPage
  },
  {
    path: '/explanation-coach-level/:type',
    meta: { title: '教练等级选择说明' },
    component: ExplanationCoachLevel
  },
  {
    path: '/reward-rules',
    meta: { title: '周月奖励规则' },
    component: RewardRules
  },
  {
    path: '/personal-information-collection-checklist',
    meta: { title: '个人信息清单' },
    component: PersonInfoCollectList
  },
  {
    path: '*',
    exact: true,
    component: errorPage
  }
]

let pathParams:any = {}
window.location.search.split('?').map((e:string) => {
  if (Object.keys(e).length) {
    const arr:string[] = e.split('&');
    arr.map(e2 => {
      const tokenObj = e2.split('=')
      return pathParams[tokenObj[0]] = tokenObj[1]
    })
  }

  return pathParams
})

const { token, from } = pathParams;
if (from === 's') {
  jumpPage(isiOS ? 'uuaudio:' : 'bogokjmobclick:')
}

if(token && token !== 'undefined') {
  localStorage.setItem("token", token);
  // 如果拿到了token，就根据token直接获取用户信息
  // getUserInfo().then(e => {
  //   // 存在localStorage里面是被充值账户的信息，而存在redux里面的是本账户的信息
  //   localStorage.setItem("userInfo", JSON.stringify(e));
  //   let action = setUserInfo(e)
    
  //   postActivityDetail({
  //     // activity_code: 'YQ002'
  //     activity_code: 'YQ001'
  //   }).then(e2 => {
  //     const obj = { ...e, invite_code: e2.pretty_number }
  //     localStorage.setItem("userInfo", JSON.stringify(obj));
  //     action = setUserInfo(obj)
  //   }).finally(() => {
  //     store.dispatch(action)
  //   })
  // }).catch(() => {})
}

export default routes